
    <ng-container *ngIf="this.router.url.includes('/mastercard-landing-page'); else mainApp">
      <ingo-mastercard-landing-page></ingo-mastercard-landing-page>
    </ng-container>
    <ng-template #mainApp>
      <ingo-main-app></ingo-main-app>
    </ng-template>
  